const SHOW_TAX_E_STATEMENTS = 'hideTaxEStatements';

export const hideTaxEStatementsModal = () =>
  localStorage.setItem(SHOW_TAX_E_STATEMENTS, 'true');

export const hasUserOptedInTaxStatements = () => {
  return localStorage.getItem(SHOW_TAX_E_STATEMENTS) === 'true';
};
